export enum EEX_PATHS {
  DOCS = "https://docs.butane.dev/",
  TWITTER = "https://twitter.com/ButaneProtocol",
}
